/**
 * Current-user account endpoints. Used by the first-login Terms & Conditions
 * gate (TermsGate): read whether this user has accepted, and record acceptance.
 */
import { api } from "./client";

export interface Me {
  email: string;
  /** ISO timestamp of the user's T&C acceptance, or null if not yet accepted. */
  terms_accepted_at: string | null;
}

export const getMe = (): Promise<Me> => api.get<Me>("/me");

export const acceptTerms = (): Promise<{ terms_accepted_at: string | null }> =>
  api.post<{ terms_accepted_at: string | null }>("/me/accept-terms");
